const fragment = `
  id
  name
  imageUrl
  priceChange
  sizeChange
  bedsChange
  bathsChange
  garagesChange
  description
  alternateImageUrl
  alternateOption
  isDefault
  imagesCount
  priceRulesCount
  lotWorksSettings
  dependenciesLogicalOperator
  availabilityRule
  availabilityCommunities
  availabilityCommunityPhases
  defaultCommunities
  dependencies {
    group
    operator
    values
  }
  isAutoSelectedByDefault
  applyFloorPlanHighlight
`;

export const listFloorOptionsQuery = `
  query listFloorOptions(
    $filter: FloorOptionFilterInput!
  ) {
    items: listFloorOptions(filter: $filter) {
      ${fragment}
      floorGroup {
        name
      }
    }
  }
`;

export const createFloorOptionQuery = `
  mutation CreateFloorOption(
    $input: CreateFloorOptionInput!
    $image: Upload
    $alternateImage: Upload
  ) {
    item: createFloorOption(input: $input, image: $image, alternateImage: $alternateImage) {
      ${fragment}
    }
  }
`;

export const updateFloorOptionQuery = `
  mutation UpdateFloorOption(
    $input: UpdateFloorOptionInput!
    $image: Upload
    $alternateImage: Upload
  ) {
    item: updateFloorOption(input: $input, image: $image, alternateImage: $alternateImage) {
      ${fragment}
    }
  }
`;

export const deleteFloorOptionQuery = `
  mutation DeleteFloorOption(
    $id: Int!
  ) {
    item: deleteFloorOption(id: $id) {
      ${fragment}
    }
  }
`;

export const sortFloorOptionsQuery = `
  mutation SortFloorOptions(
    $floorGroupId: Int!,
    $ids: [Int!]!
  ) {
    items: sortFloorOptions(floorGroupId: $floorGroupId, ids: $ids) {
      ${fragment}
    }
  }
`;
